import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Typography } from '@material-ui/core';

const EmailVerified = ({ classes }) => (
    <div>
        <Typography variant={'h6'} className={`u-mb-medium `}>
            Email Verification Complete
        </Typography>
        <p>We have successfully verified your email.</p>
        <div className="row u-mb-small">
            <div className={'u-pt-medium col-6 offset-3'}>
                <Link className={classes.buttonPrimary} to={'/login'}>
                    Login
                </Link>
            </div>
        </div>
    </div>
);

EmailVerified.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default EmailVerified;
